import React, { useContext } from 'react';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import successPic from '../../../images/success-icon-2.png';

import './style.scss';

const SuccessPopup = ({
   title, subTitle, buttonText,
}) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('title')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t(subTitle)}</p>
        <img alt="success-icon" className="success-icon" src={successPic} />
      </div>
      <button
        type="button"
        className="popup-confirm-button"
        onClick={closePopup}
      >
        {t(buttonText || 'Done')}
      </button>
    </div>
  );
};

export default SuccessPopup;
